/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CreateCommissionRateRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CommissionRateMassCreates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name CreateCommissionRate
   * @request POST:/commissionRate-mass-creates
   * @secure
   */
  createCommissionRate = (data: CreateCommissionRateRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commissionRate-mass-creates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCommissionRateMassCreates
   * @request OPTIONS:/commissionRate-mass-creates
   */
  optionsCommissionRateMassCreates = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commissionRate-mass-creates`,
      method: 'OPTIONS',
      ...params,
    });
}
